import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { publicReducer } from "./reducers/public";
import { companyReducer } from "./reducers/company";
import { auctionReducer } from "./reducers/auction";
import { authReducer } from "./reducers/auth";
import { announcementReducer } from "./reducers/announcement";
import { planReducer } from "./reducers/plan";
import {planItemReducer} from "./reducers/planItem";
import {lotReducer} from "./reducers/lot";

const rootReducer = combineReducers({
  public: publicReducer,
  company: companyReducer,
  auction: auctionReducer,
  auth: authReducer,
  announcement: announcementReducer,
  plan: planReducer,
  planItem: planItemReducer,
  lot: lotReducer
});

export const store = createStore(
  rootReducer,
  composeWithDevTools()
);

export type State = ReturnType<typeof rootReducer>;